module.exports = __webpack_public_path__ + "img/ill_block_2.f7442d34.png";